import { CSS_PROPERTIES } from '@wix/component-protocol/schema';

export const CORNER_DIRECTIONS = [
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopLeftRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopRightRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomLeftRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomRightRadius,
] as const;

export const CORNER_LOGICAL_DIRECTIONS = [
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStartStartRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStartEndRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderEndStartRadius,
  CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderEndEndRadius,
] as const;

export const COMBINED_CORNER_PROPERTIES = [
  ...CORNER_DIRECTIONS,
  ...CORNER_LOGICAL_DIRECTIONS,
] as const;

export type CornerProperty = (typeof COMBINED_CORNER_PROPERTIES)[number];
